import { FolkXanadu } from '../folk-xanadu';
FolkXanadu.define();
export { FolkXanadu };
//# sourceMappingURL=folk-xanadu.js.map